import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import style from '../../../styling/Panels.module.css';
import Modal from 'react-modal';

import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

Modal.setAppElement('#root')

const GET_SCHOOLS = gql`
    query get_schools {
        schools {
            id
            name
        }
    }
`;
const PUT_CLASSROOM = gql`
    mutation put_classroom($id: ID!, $name: String!) {
        updateClassroom(
            id: $id,
            name: $name
        ) {
            id
        }
    }
`;
const POST_CLASSROOM = gql`
    mutation post_classroom($name: String!) {
        createClassroom(
            name: $name
        ) {
            id
        }
    }
`;

function Toast(message) {
	toast.success(message);
}

const customStyles = {
	content : {
	    top                   : '30%',
	    left                  : '50%',
	    right                 : 'auto',
	    bottom                : 'auto',
	    marginRight           : '-50%',
	    transform             : 'translate(-50%, -50%)',
	    border                : '1px solid #878787',
		padding				  : 0,
		boxShadow             : '0px 8px 15px rgba(181, 181, 181, 0.8)',
	}
};

export default function EditStudentModal (props) {
	const [ modalIsOpen, setIsOpen ] = React.useState(false)
    
	function openModal() {
	  setIsOpen(true)
	}

	function closeModal () {
		setIsOpen(false)
	}

	function clearFields() {
		set_name()
	}

	const [ name, set_name ] = useState(props.classroom ? props.classroom.name : '')

	const [ redirect, setRedirect ] = React.useState(false)

	const [put_classroom, { put_data } ] = useMutation(PUT_CLASSROOM)
	const [post_classroom, { post_data } ] = useMutation(POST_CLASSROOM)

	const handleSubmit = e => {
		e.preventDefault();
		if (props.usage === 'Create') {
			post_classroom({ 
				variables: {
					name: name
				}
			});
			Toast("Classroom Created");
			closeModal();
			clearFields();
		}
		else {
			put_classroom({ 
				variables: {
					id: props.classroom.id,
					name: name
				}
			});
			Toast("Classroom Edited");
			return setRedirect(true);
		}
	}

	return (
		<>
			{ 
				(props.usage === 'Create') ? 
					<button onClick={ openModal } className={ style.standalone_button }>{ props.usage }</button> :
					<button onClick={ openModal } className={ style.td_button + ' ' + style.submit_text }>{ props.usage }</button> 
			}
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={closeModal}
				contentLabel="Update Classroom"
				style={ customStyles }
			>
				<div className={ style.panel_row } style={{ marginBottom: 0 }}>
					<div className={ style.panel + ' ' + style.panel_modal }>
						<h3>{ props.usage } Classroom</h3>
						<form onSubmit={ handleSubmit }>
							<table>
								<thead>
									<tr>
										<th>Name</th>
										<td><input type="text" value={ name } onChange={ e => set_name(e.target.value) } /></td>
									</tr>
								</thead>
							</table>
							<div style={{ margin: 'auto', width: '50%'}}>
								<div style={{ display: 'flex'}}>
									<button className={ style.form_button } onClick={closeModal}>Cancel</button>
									<button className={ style.form_button } type="submit">{ props.usage }</button>
								</div>
							</div>
						</form>
					</div>
				</div>
				{ redirect ? <Redirect to={ "/classrooms" } /> : null }
			</Modal>
		</>
	);
}